// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33Owa","footer":"styles_footer__sHPgS","passCodeTooltip":"styles_passCodeTooltip__2UgCi"};